import Vue from "vue";
import Vuex, { MutationTree, ActionTree } from "vuex";
import { Status } from "../../../models/status";
import axios from 'axios';

Vue.use(Vuex);

interface State {
    status: Array<Status>;
}

const mutations: MutationTree<State> = {
    setStatus: (state, status) => (state.status = status),
};

const actions: ActionTree < State, any > = {

};

const getters = {
   
    status(state: State)  {
        return state.status
    },
};


const state: State = {
    status: Array<Status>(),
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/vuex/modules/status/store.ts